export default "__VITE_ASSET__dd1d5369__"